import type { TealiumEventData } from 'src/types/trackingData';

import { EVENT_NAME_INTERACTION } from '.';

const SAVE_CREDIT_CARD_CLICKED = 'ecaja-save-credit-card-interacted';
export const saveCreditCardClicked: TealiumEventData = {
  linkName: SAVE_CREDIT_CARD_CLICKED,
  eventName: [SAVE_CREDIT_CARD_CLICKED, EVENT_NAME_INTERACTION],
  objectInteraction: 'save-credit-card',
};

const SAVE_CREDIT_CARD_UNCHECKED = 'ecaja-save-credit-card-unchecked';
export const saveCreditCardUnchecked: TealiumEventData = {
  linkName: SAVE_CREDIT_CARD_UNCHECKED,
  eventName: [SAVE_CREDIT_CARD_UNCHECKED, EVENT_NAME_INTERACTION],
  objectInteraction: 'save-credit-card-unchecked',
};

const CHECKOUT_BUTTON_CLICKED = 'ecaja-checkout-back-interacted';
export const backButtonClicked: TealiumEventData = {
  linkName: CHECKOUT_BUTTON_CLICKED,
  eventName: [CHECKOUT_BUTTON_CLICKED, EVENT_NAME_INTERACTION],
};

const PREMIUM_UPSELL_IMPRESSION = 'ecaja-premium-upsell-impression';
export const premiumUpsellImpression: TealiumEventData = {
  linkName: PREMIUM_UPSELL_IMPRESSION,
  eventName: [PREMIUM_UPSELL_IMPRESSION],
  adBudgetType: 'premiumUpsell',
};

const PREMIUM_UPSELL_UPGRADE_CLICKED = 'ecaja-premium-upsell-selected';
export const premiumUpsellUpgrade: TealiumEventData = {
  linkName: PREMIUM_UPSELL_UPGRADE_CLICKED,
  eventName: [PREMIUM_UPSELL_UPGRADE_CLICKED, EVENT_NAME_INTERACTION],
  objectInteraction: 'premiumUpsell',
  productCategories: 'jobAd',
  productEvents: ['add'],
  productIds: ['premiumUpsell'],
  productQuantities: 1,
};

const PREMIUM_REMOVE_UPGRADE_CLICKED = 'ecaja-premium-upsell-deselected';
export const premiumUpsellRemoveUpgrade: TealiumEventData = {
  linkName: PREMIUM_REMOVE_UPGRADE_CLICKED,
  eventName: [PREMIUM_REMOVE_UPGRADE_CLICKED, EVENT_NAME_INTERACTION],
  objectInteraction: 'premiumUpsell',
  productCategories: 'jobAd',
  productEvents: ['remove'],
  productIds: ['premiumUpsell'],
  productQuantities: 1,
};

const REPLACE_SAVED_CREDIT_CARD_INTERACTED =
  'ecaja-replace-credit-card-interacted';
export const savedCreditCardInteracted: TealiumEventData = {
  linkName: REPLACE_SAVED_CREDIT_CARD_INTERACTED,
  eventName: [REPLACE_SAVED_CREDIT_CARD_INTERACTED, EVENT_NAME_INTERACTION],
  objectInteraction: 'replace-credit-card-interacted',
};
